import { render, staticRenderFns } from "./OwnersListTable.vue?vue&type=template&id=898ebf94&scoped=true&"
import script from "./OwnersListTable.vue?vue&type=script&lang=js&"
export * from "./OwnersListTable.vue?vue&type=script&lang=js&"
import style0 from "./OwnersListTable.vue?vue&type=style&index=0&id=898ebf94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898ebf94",
  null
  
)

export default component.exports